import React, {PropTypes} from 'react';
import Modal from '../../../Modal';
import Form, { FormBody, FormActions, TextInput, SelectInput, DateInput, ColorInput } from '../../../Form';
import {inject, observer} from 'mobx-react';
import {observable, action, toJS} from 'mobx';
import moment from 'moment';

@inject('ticketActionStore')
@observer
export default class ActionAdd extends React.Component {

  static propTypes = {
    route: PropTypes.shape().isRequired,
  }

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  }

  slug = '/monitoring/config/action';
  @observable item = {
    caption : '',
    description: '',
    color: '#000000'
  };

  @action onChangeCaption = e => this.item.caption = e.target.value;
  @action onChangeDescription = e => this.item.description = e.target.value;
  @action onChangeColor = e => this.item.color = e.target.value;


  handleSave = e => {
    e.preventDefault();

    const {ticketActionStore} = this.props;
    const { notify } = this.context;

    ticketActionStore.createItem(this.item)
      .then(() => {
        notify.success({ message: 'Success' });
        this.context.router.push(this.slug);
      })
      .catch(err => {
        notify.error(err);
        this.context.router.push(this.slug);
      });
  };

  render() {
    const {ticketActionStore} = this.props;
    // const {stationStore, userStore} = this.props;
    // console.log(userStore.items)
    return (
      <Modal slug={this.slug} title='Add Ticket Action' isSaving={ticketActionStore.isSaving}>
        <Form>
          <FormBody>
            <TextInput label='Caption' value={this.item.caption} onChange={this.onChangeCaption}/>
            <TextInput label='Description' value={this.item.description} onChange={this.onChangeDescription}/>
            <ColorInput label='Color' value={this.item.color} onChange={this.onChangeColor}/>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/Configuration/Action/ActionAdd.js